import React from 'react';
import MetaTags from '../components/MetaTags';
import AuditionCategoryRow from '../components/AuditionCategoryRow';
import JourneyCTA from '../components/JourneyCTA';
import InstantAIScoring from '../components/InstantAIScoring';
import AuditionTypes from '../components/AuditionTypes';
import TestimonialAndDirectors from '../components/TestimonialAndDirectors'; // <-- IMPORT NEW COMPONENT

import '../App.css'; // Your main app styles
import BannerSlider from '../components/BannerSlider';

const HomePage = () => {
 const pageMeta = {
    // title: "Home - BookMyAudition",
    // description: "Find the latest acting auditions in India. Connect with casting directors for Bollywood, TV serials, ad films, and web series.",
    title: "Acting Auditions in Mumbai & Bollywood | BookMyAudition",
    description: "Join India's leading platform for acting auditions. Find verified roles for Bollywood movies, TV serials, and web series. Connect with top casting directors.",
    keywords: "acting auditions, bollywood auditions, casting directors mumbai, acting jobs india, singing auditions",
    // imageUrl: "https://bma.on.joget.cloud/jw/web/app/bookmyaudition/resources/bma_logo.png", // Optional: if different from default
    // url: "http://localhost:3000/" // Optional: if different from default
    imageUrl: "https://web.bookmyaudition.com/social_logo.jpg", 
    url: "https://web.bookmyaudition.com/" 
  };
  return (
    <> {/* Using Fragment shorthand */}
      <MetaTags
        title={pageMeta.title}
        description={pageMeta.description}
      sssssss keywords={pageMeta.keywords}
      url={pageMeta.url}
      image={pageMeta.imageUrl}
      />
      {/* <main className="main-container-custom"> */}
      <main className="main-container-custom">
      <h1 className="visually-hidden" style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', border: '0' }}>
        Latest Acting Auditions in India - Bollywood, Web Series & TV
      </h1>
        <BannerSlider />

        <AuditionCategoryRow/>
        <TestimonialAndDirectors />

        {/* <InstantAIScoring /> */}
        <AuditionTypes />
        <JourneyCTA />
      </main>
      {/* <FooterComponent /> */}
    </>
  );
};

export default HomePage;